import React, { Component } from "react";
import api from "../../../api/api";
import CookieHandler from "../../common/CookieHandler";
import config from "../../../config/config";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import { localDateFormate, pad, toLocaleString } from "../../common/common";
import ViewFiles from "../../common/ViewFiles";
import InvoiceForm from "../../common/InvoiceForm";
import PaymentPostings from "../../common/PaymentPostings";
import InvoiceLink from "../../InvoicePdf/InvoiceLink";
import Loader from "../../common/Loader";
import BusinessApproveButton from "../../Approvals/BusinessApproveButton";
import AuditInfo from "../../common/AuditInfo";

export default class CoalProcurementChargesView extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();
    this.state = {
      isLoading: true,
      features: [],
      cpc_costing_list: [],
      multiRows: [],
      files: [],
      activeStep: 0,
      financial_data: "",
      payment_due_date: null,
      invoiceDialog: false,
      paymentMode: "Add",
      mv_name: "",
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    }
    const features = this.Cookie.getCookie("features");
    this.setState({ features: features });
    if (
      !(
        features.includes("143") ||
        features.includes("392") ||
        features.includes("443") ||
        features.includes("97")
      )
    ) {
      window.location.href = "/dashboard";
    }
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    const costing_id = this.props.costing_id;
    await api
      .get_barge_pur_fin_cpc(loginUserID, idToken, costing_id)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.barge_purchase_financial_cpc) {
                var total_payment_amount = 0;
                var remaining_amount = 0;

                for (
                  var i = 0;
                  i < res.barge_purchase_financial_cpc.length;
                  i++
                ) {
                  if (
                    res.barge_purchase_financial_cpc[i].cpc_payments.length > 0
                  ) {
                    for (
                      var j = 0;
                      j <
                      res.barge_purchase_financial_cpc[i].cpc_payments.length;
                      j++
                    ) {
                      if (
                        res.barge_purchase_financial_cpc[i].cpc_payments[j]
                          .date_of_payment
                      ) {
                        total_payment_amount += Number(
                          res.barge_purchase_financial_cpc[i].cpc_payments[j]
                            .amount
                        );
                      }
                      remaining_amount =
                        Number(
                          res.barge_purchase_financial_cpc[i].payable_to_vendor
                        ) - Number(total_payment_amount);
                    }
                    res.barge_purchase_financial_cpc[i].total_payment_amount =
                      total_payment_amount;
                    res.barge_purchase_financial_cpc[i].remaining_amount =
                      remaining_amount;
                  } else {
                    res.barge_purchase_financial_cpc[i].remaining_amount =
                      Number(
                        res.barge_purchase_financial_cpc[i].payable_to_vendor
                      );
                  }
                }
                this.setState(
                  {
                    invoice_file:
                      res.barge_purchase_financial_cpc[0]?.invoice_file,
                    costing_no: res.barge_purchase_financial_cpc[0]?.costing_no,
                    invoice_date:
                      res.barge_purchase_financial_cpc[0]?.invoice_date,
                    invoice_no: res.barge_purchase_financial_cpc[0]?.invoice_no,

                    payee_name: res.barge_purchase_financial_cpc[0]?.payee_name,
                    vat_value: res.barge_purchase_financial_cpc[0]?.vat_value,
                    payment_to_vendor_name:
                      res.barge_purchase_financial_cpc[0]
                        ?.payment_to_vendor_name,

                    payable_to_vendor:
                      res.barge_purchase_financial_cpc[0]?.payable_to_vendor,
                    base_price: res.barge_purchase_financial_cpc[0]?.base_price,
                    base_price_pmt:
                      res.barge_purchase_financial_cpc[0]?.base_price_pmt,

                    currency_xchg_rate:
                      res.barge_purchase_financial_cpc[0]?.currency_xchg_rate,
                    barge_quantity:
                      res.barge_purchase_financial_cpc[0]?.barge_quantity,
                    pph23_value:
                      res.barge_purchase_financial_cpc[0]?.pph23_value,

                    barge_id:
                      res.barge_purchase_financial_cpc[0]?.barge_group_id,

                    billing_currency:
                      res.barge_purchase_financial_cpc[0]?.billing_currency,
                    multiRows: res.barge_purchase_financial_cpc,
                    files: res.files ? res.files : [],
                    isLoading: false,
                  },
                  () => {
                    const split_barge_id = this.state.barge_id?.split(",")[0];

                    let request = {
                      login_user_id: this.Cookie.getCookie("loginUserId"),
                      idtoken: this.Cookie.getIdTokenCookie(),
                      barge_id: split_barge_id,
                      vendor_type: "Barge",
                    };
                    api
                      .get_business_no_info_for_barge(request)
                      .then((response) => {
                        if (response.status >= 200 && response.status < 300) {
                          response.json().then((res) => {
                            if (res.code === "200") {
                              this.setState({
                                vendor_name: res.vendor_name,
                                mv_name: res.mv_name,
                              });
                            }
                          });
                        }
                      });
                  }
                );
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "601") {
              this.setState({
                errorMsg: res.message,
                successMsg: "",
                isLoading: false,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });

    const barge_name = "",
      jetty_name = "";
    await api
      .get_barges_for_pur_fin_cpc(loginUserID, idToken, barge_name, jetty_name)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.barges) {
                let newData = [];
                var result = res.barges.reduce(function (r, a) {
                  r[a.id] = r[a.id] || [];
                  r[a.id].push(a);
                  return r;
                }, Object.create(null));
                for (let l = 0; l < Object.keys(result).length; l++) {
                  newData.push({
                    new_barges: result[Object.keys(result)[l]],
                  });
                }
                let purchase_contracts_barges = newData;
                if (newData.length === 0) {
                  this.setState({
                    snackBarErrorOpen: true,
                    errorMsg: "No records to display",
                  });
                }
                this.setState({
                  cpc_costing_list: purchase_contracts_barges,
                  id: res.barges[0].id,
                  isLoading: false,
                });
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
  }

  updateInvoice = (data) => {
    let request = {
      ...data,
      table_name: "barge_purchase_financial_cpc",
    };
    api.update_invoice_details(request).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.code === "200") {
            this.componentDidMount();
            this.setState({
              invoiceDialog: false,
            });
          }
        });
      }
    });
  };

  renderPaymentPostings = (data) => {
    const {
      id,
      cpc_payments = [],
      invoice_no = null,
      remaining_amount = 0,
      billing_currency,
      currency_xchg_rate = 1,
      approval_status = "Pending",
    } = data;
    let payment_related_data = {
      paymentTitle: "Coal Procurement",
      payment_posting_type: "coal_procurement",
      invoice_no: invoice_no,
      outstanding_amount: remaining_amount,
      billing_currency: billing_currency
        ? billing_currency
        : config.company === "SRPL" ||
          config.company === "PRPL" ||
          config.company === "AVS"
        ? "USD"
        : "IDR",
      currency_xchg_rate: currency_xchg_rate ? currency_xchg_rate : 1,
      costing_id: id,
      login_user_id: this.Cookie.getCookie("loginUserId"),
      idtoken: this.Cookie.getIdTokenCookie(),
    };
    let access_details = {
      costing_approval: approval_status,
      add_payment: "146",
      view_payment: "147",
      update_payment: "148",
      delete_payment: "149",
      approver: "393",
      approver2: "444",
    };

    return (
      <PaymentPostings
        payments={cpc_payments}
        costingType="Coal Procurement Charges"
        data={payment_related_data}
        access_details={access_details}
        callbackFn={() => {
          this.componentDidMount();
        }}
      />
    );
  };

  renderInvoiceLink = () => {
    const data = this.state.cpc_costing_list.map((e) =>
      e.new_barges.filter((obj) => obj.id === this.props.costing_id)
    );
    const {
      costing_no,
      payment_to_vendor_name = "",
      payee_name = "",
      payable_to_vendor,
      invoice_no = "",
      invoice_date = "",
      base_price = 0,
      barge_quantity = 0,
      base_price_pmt = 0,
      pph23_value = 0,
      vat_value = 0,
    } = this.state;

    const Grand_total = parseFloat(
      payable_to_vendor ? payable_to_vendor : 0
    ).toFixed(2);
    let to_vendor = payment_to_vendor_name;
    if (to_vendor === null || !to_vendor) {
      to_vendor = payee_name;
    }
    const invoiceObject = {
      costing_id: costing_no,
      to: to_vendor,
      business_no: this.state.mv_name,
      costing_name: "Coal Procurement Charges",
      invoice_no: invoice_no,
      invoice_date: localDateFormate(invoice_date),
      bargeDetails: data ? data.flat() : [],
      billing_currency:
        config.company === "PRPL" ||
        config.company === "SRPL" ||
        config.company === "AVS"
          ? "USD"
          : "IDR",
      total_payable_amount: toLocaleString(Grand_total),
      purchase_type: "FOB Barge",
      description: [
        {
          qty: toLocaleString(barge_quantity),
          adjustedPrice: toLocaleString(base_price_pmt),
          desc: `${
            this.state.currency_xchg_rate > 1
              ? `Coal Procurement @ ${parseFloat(
                  this.state.currency_xchg_rate
                ).toFixed(2)}`
              : "Coal Procurement"
          }`,
          amount: base_price,
        },
        ...(this.state.pph15_account !== "SDAM" && vat_value > 0
          ? [
              {
                qty: " ",
                adjustedPrice: " ",
                desc: "VAT",
                amount: `${toLocaleString(vat_value)}`,
              },
            ]
          : []),
        ...(!(
          config.company === "SRPL" ||
          config.company === "PRPL" ||
          config.company === "AVS"
        ) && pph23_value
          ? [
              {
                qty: " ",
                adjustedPrice: " ",
                desc: "PPH",
                amount: `( ${toLocaleString(pph23_value)} )`,
              },
            ]
          : []),
      ],
    };
    return <InvoiceLink data={invoiceObject} fileName={costing_no} />;
  };

  render() {
    const CostingID = this.props.costing_id;
    if (this.state.isLoading) {
      return <Loader />;
    } else {
      return (
        <div className="container bg-white p-0" style={{ minHeight: "100vh" }}>
          <div className="clearfix content-header border-bottom">
            <div className="row">
              <div className="col-sm text-left pl-0">
                <h4 style={{ padding: "10px 20px", margin: "0px" }}>
                  {`Coal Procurement
                  Charges - ${this.state?.costing_no}`}
                </h4>
              </div>
              <div className="col-lg-1 pl-0 float-right">
                {this.renderInvoiceLink()}
              </div>
            </div>
          </div>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>

          <div className="drawer-section">
            <div className="card">
              {this.state.cpc_costing_list.length > 0 && (
                <div className="row mb-2">
                  <div className="table-responsive">
                    <table className="table table-bordered table-sm mb-0">
                      <thead className="table-header">
                        <tr>
                          <th nowrap="true">Barge ID</th>
                          <th nowrap="true">Barge Nomination</th>
                          <th nowrap="true">Business No</th>
                          <th nowrap="true">Barge Vendor</th>
                          <th nowrap="true" className="text-right">
                            Quantity
                          </th>
                          <th nowrap="true" className="text-right">
                            Price PMT{" "}
                          </th>
                          <th nowrap="true" className="text-right">
                            Total Payable
                          </th>
                          <th nowrap="true" className="text-right">
                            Paid{" "}
                          </th>
                          <th nowrap="true" className="text-right">
                            Remaining{" "}
                          </th>
                        </tr>
                      </thead>
                      {this.state.cpc_costing_list.map((p, index) => (
                        <tbody key={index}>
                          {p.new_barges.map((idr, indx) => (
                            <tr
                              key={indx}
                              style={{
                                display: CostingID === idr.id ? "" : "none",
                              }}
                            >
                              <td>
                                <a
                                  href={"/view-barge/" + btoa(idr.barge_id)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: config.themeColor }}
                                >
                                  {pad(idr.barge_id)}
                                </a>
                              </td>
                              <td nowrap="true">{idr.barge_nomination}</td>
                              <td nowrap="true">{idr.business_no}</td>
                              <td nowrap="true">{idr.vendor}</td>
                              {indx === 0 && (
                                <td
                                  className="text-right"
                                  nowrap="true"
                                  rowSpan={p.new_barges.length}
                                >
                                  {toLocaleString(idr.barge_quantity)}
                                </td>
                              )}
                              {indx === 0 && (
                                <td
                                  className="text-right"
                                  nowrap="true"
                                  rowSpan={p.new_barges.length}
                                >
                                  {toLocaleString(idr.price_per_mt)}
                                </td>
                              )}
                              {indx === 0 && (
                                <td
                                  className="text-right"
                                  nowrap="true"
                                  rowSpan={p.new_barges.length}
                                >
                                  {toLocaleString(idr.total_payable)}
                                </td>
                              )}
                              {indx === 0 && (
                                <td
                                  className="text-right"
                                  nowrap="true"
                                  rowSpan={p.new_barges.length}
                                >
                                  {toLocaleString(idr.paid)}
                                </td>
                              )}
                              {indx === 0 && (
                                <td
                                  className="text-right"
                                  nowrap="true"
                                  rowSpan={p.new_barges.length}
                                >
                                  {toLocaleString(idr.Remaining_amount)}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      ))}
                    </table>
                  </div>
                </div>
              )}

              <div className="col shadow-sm p-0 mb-2 bg-white border">
                {/* New Changes */}
                <div className="table-responsive">
                  <table className="table table-sm table-bordered mb-0">
                    <thead className="table-header">
                      <tr>
                        <th className="text-center">Description</th>
                        <th className="text-right">Qty</th>
                        <th className="text-right">Unit Price</th>
                        <th className="text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.multiRows.map((e, index) => (
                        <>
                          <tr>
                            <td>
                              Coal Procurement
                              {this.state.currency_xchg_rate > 1 && (
                                <div>
                                  Exchange Rate @{" "}
                                  {parseFloat(
                                    this.state.currency_xchg_rate
                                  ).toFixed(2)}
                                </div>
                              )}
                            </td>
                            <td className="text-right">
                              {toLocaleString(e.barge_quantity)}
                            </td>
                            <td className="text-right">
                              {toLocaleString(e.base_price_pmt)}
                            </td>
                            <td className="text-right">
                              {toLocaleString(e.base_price)}
                            </td>
                          </tr>
                          {(this.state.vat_applicability === "Inclusive" ||
                            config.company !== "SRPL" ||
                            config.company !== "PRPL" ||
                            config.company !== "AVS") &&
                            e.vat_value > 0 && (
                              <tr>
                                <td>VAT @ 10 %</td>
                                <td className="text-right"></td>
                                <td className="text-right"></td>
                                <td className="text-right">
                                  {toLocaleString(e.vat_value)}
                                </td>
                              </tr>
                            )}
                          {!(
                            config.company === "SRPL" ||
                            config.company === "AVS" ||
                            config.company === "PRPL"
                          ) &&
                            e.pph23_account === "Supplier" &&
                            e.pph23_value && (
                              <tr>
                                <td>
                                  PPH23 @ {toLocaleString(e.pph23_percent)} %{" "}
                                </td>
                                <td></td>
                                <td></td>
                                <td className="text-right">
                                  ({toLocaleString(e.pph23_value)})
                                </td>
                              </tr>
                            )}
                          {!(
                            config.company === "SRPL" ||
                            config.company === "AVS" ||
                            config.company === "PRPL"
                          ) &&
                            e.pph23_account === "SDAM" &&
                            e.pph23_value && (
                              <tr>
                                <td>
                                  PPH23 @{toLocaleString(e.pph23_percent)}{" "}
                                </td>
                                <td></td>
                                <td></td>
                                <td className="text-right">
                                  ({toLocaleString(e.pph23_value)})
                                </td>
                              </tr>
                            )}

                          <tr>
                            <td
                              colSpan={3}
                              style={{ fontWeight: "bold" }}
                              className="text-right "
                            >
                              {" "}
                              Payable to Vendor :{" "}
                            </td>
                            <td
                              style={{ fontWeight: "bold" }}
                              className="text-right "
                            >{`${
                              config.company === "SRPL" ||
                              config.company === "PRPL" ||
                              config.company === "AVS"
                                ? "USD"
                                : "IDR"
                            } ${toLocaleString(
                              parseFloat(e.payable_to_vendor)
                            )} `}</td>
                          </tr>
                          <tr>
                            {e.total_paid_amout ? (
                              <>
                                <td
                                  colSpan={3}
                                  style={{ fontWeight: "bold" }}
                                  className="text-right "
                                >
                                  Paid to Vendor
                                </td>
                                <td>
                                  {config.company === "SRPL" ||
                                  config.company === "AVS" ||
                                  config.company === "PRPL"
                                    ? " USD"
                                    : " IDR"}{" "}
                                  {toLocaleString(e.total_paid_amout)}{" "}
                                </td>
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                          <tr>
                            {e.remaining_amount ? (
                              <>
                                <td
                                  colSpan={3}
                                  style={{ fontWeight: "bold" }}
                                  className="text-right "
                                >
                                  Remaining Amount
                                </td>
                                <td
                                  style={{ fontWeight: "bold" }}
                                  className="text-right "
                                >
                                  {config.company === "SRPL" ||
                                  config.company === "AVS" ||
                                  config.company === "PRPL"
                                    ? " USD"
                                    : " IDR"}{" "}
                                  {toLocaleString(e.remaining_amount)}{" "}
                                </td>
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {this.state.multiRows.map((e, idx) => (
                <div className="row mb-2 pt-2 pl-1 border rounder" key={idx}>
                  <div className="col-lg-12">
                    <div className="row">
                      {e.approval_status === "Pending" &&
                        e.invoice_file &&
                        this.Cookie.getCookie("loginUserId") !== e.created_by &&
                        e.approved_by !==
                          this.Cookie.getCookie("loginUserId") &&
                        (this.state.features.includes("392") ||
                          this.state.features.includes("443") ||
                          this.state.features.includes("97")) && (
                          <BusinessApproveButton
                            costingID={e.id}
                            costingType={"Coal Procurement Charges"}
                            accessInfo={{
                              ...e,
                              approver_1: "392",
                              approver_2: "443",
                            }}
                            callbackFn={() => this.componentDidMount()}
                          />
                        )}
                      <div className="col-lg-12 p-0">
                        <InvoiceForm
                          open={this.state.invoiceDialog}
                          costingID={e.id}
                          data={e}
                          callbackFn={(data) => this.updateInvoice(data)}
                        />

                        <div className="row">
                          {this.renderPaymentPostings(e)}
                        </div>
                        <ViewFiles
                          {...this.props}
                          type="Costings"
                          invoice_file={e.invoice_file}
                          files_data={e.files}
                        />
                        <AuditInfo info={e} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="row col-lg-12 modal-footer justify-content-end bottom_buttons_section"
            style={{ bottom: 0, background: "white" }}
          >
            <button
              type="button"
              className="drawer_button drawer_text drawer_calculate_button drawer_calculate_adjustment"
              onClick={() => this.props.onCancel(false)}
            >
              Cancel
            </button>
            {this.props.onEdit && (
              <button
                type="button"
                className="drawer_button drawer_text"
                onClick={() => this.props.onEdit(true)}
              >
                Edit
              </button>
            )}
          </div>
        </div>
      );
    }
  }
}
